import styled from 'styled-components';

const UserName = styled.span`
  color: #888;
  display: block;
  font-size: 12px;
`;

export default UserName;
